/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Frame from "./Frame";
import TopMat from "./TopMat";
import MiddleMat from "./MiddleMat";
import Glass from "./Glass";
import Printing from "./Printing";
import FramedSize from "./FramedSize";
import WindowSize from "./WindowSize";
import Plaque from "./Plaque";
import MatStyle from "./MatStyle";
import Sizes from "../../Tabs/Sizes";

class FramingOptions extends Component {
  render() {
    return (
      <>
        <div className="cont_rgt_middle">
          <h2>Window size</h2>
          <Sizes title={false} hasUpdate={true} {...this.props} />
        </div>
        <div className="cont_rgt_middle">
          <h2>Mat Board Options</h2>
          <table className="table cont_rgt_middle_table">
            <tbody>
              <MatStyle {...this.props} />
              <TopMat {...this.props} />
              <MiddleMat {...this.props} />
              <Glass {...this.props} />
              <Printing {...this.props} />
              <WindowSize {...this.props} />
              <Plaque {...this.props} />
              <Frame {...this.props} />
              <FramedSize {...this.props} />
            </tbody>
          </table>
        </div>
      </>
    );
  }
}

export default FramingOptions;
